import { useIntl } from "react-intl";

import { OccurrenceImportFileUpload } from "./components/fileUpload";
import { FileValidation } from "./components/fileValidation";
import { ImportResult } from "./components/importResult";

import { useOccurrenceImport } from "./useOccurrenceImport";

interface OccurrenceImportProps {
    show: boolean
    onCreateSingleOccurrence: () => void
    onClose: () => void
}

export const OccurrenceImport = (props: OccurrenceImportProps) => {
    const intl = useIntl()

    const {
        occurrenceImportStep,

        dowloadingTemplate,
        isDragActive,
        selectedFile,
        canImport,
        errorMessage,
        validatingFile,
        handleGetTemplate,
        handleDragEnter,
        handleDragOver,
        handleDragLeave,
        handleDrop,
        handleFileInputChange,
        clearSelectedFile,
        validateFile,

        validationResponse,
        importing,
        handleImport,

        importResponse,
    } = useOccurrenceImport(intl)

    return (
        <>
            {occurrenceImportStep === "fileSelection" ? 
                <OccurrenceImportFileUpload
                    show={props.show}
                    dowloadingTemplate={dowloadingTemplate}
                    isDragActive={isDragActive}
                    selectedFile={selectedFile}
                    canImport={canImport}
                    errorMessage={errorMessage}
                    validatingFile={validatingFile}

                    onClose={props.onClose}
                    onCreateSingleOccurrence={props.onCreateSingleOccurrence}
                    handleGetTemplate={handleGetTemplate}
                    handleDragEnter={handleDragEnter}
                    handleDragOver={handleDragOver}
                    handleDragLeave={handleDragLeave}
                    handleDrop={handleDrop}
                    handleFileInputChange={handleFileInputChange}
                    clearSelectedFile={clearSelectedFile}
                    validateFile={validateFile}
                /> : null}

            {occurrenceImportStep === "fileValidation" && validationResponse ?
                <FileValidation
                    show={props.show}
                    selectedFile={selectedFile}
                    validationResponse={validationResponse}
                    importing={importing}
                    
                    onClose={() => [props.onClose(), clearSelectedFile()]}
                    handleRetry={clearSelectedFile}
                    handleImport={handleImport}
                /> : null}

            {occurrenceImportStep === "importResult" && importResponse ? (
                <ImportResult
                    show={props.show}
                    selectedFile={selectedFile}
                    importResponse={importResponse}
                    
                    onClose={() => [props.onClose(), clearSelectedFile()]}
                />
            ) : null}
        </>
    )
}